import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import setAuthToken from './setToken';
import { authService } from '../services/authServices';
import axios, { AxiosResponse } from 'axios';

interface ErrorResponse {
    response?: {
        status: number;
        msg?: string;
        data?: { data?: string };
    };
}

export const apiErrorHandler = async (
    error: ErrorResponse | any,
    dispatch: Dispatch<any>,
    signOut: () => void
): Promise<void> => {
    const response = error?.response || {};
    const isExecuted = localStorage.getItem('toast');

    if (response && response?.data) {
        switch (response?.status) {
            case 401:
                if (isExecuted === null || isExecuted === 'false') {
                    toast.error(
                        response?.msg || 'Session Expired! Please login again to continue.'
                    );
                    localStorage.setItem('toast', 'true');
                }
                if (signOut) {
                    dispatch(signOut());
                }
                break;
            default:
                toast.error(response?.data ? response?.data?.data : 'Something went wrong!');
                break;
        }
    }
    else {
        toast.error("An unexpected error occurred.");
    }
};


/* export const postRequest = async (apiUrl, data) => {
    let headers = {
        platform: "web",
        lang: localStorage.getItem("user-language") || "en",
    };
    setAuthToken(authService.getToken());
    return await axios.post(apiUrl, data, { headers });
};

export const deleteRequest = async (apiUrl) => {
    let headers = {
        platform: "web",
        lang: localStorage.getItem("user-language") || "en",
    };
    setAuthToken(authService.getToken());

    return await axios.delete(apiUrl, { headers });
}; */

/* export const getRequest = async <T>(
    apiUrl: string,
    params: Record<string, any> = {}
): Promise<AxiosResponse<T>> => {
    const headers = {
        Accept: "application/json",
        platform: "web",
        // lang: localStorage.getItem("user-language") || "en",
        Authorization: `Bearer ${authService.getToken()}`,
    };

    // const token = authService.getToken();
    setAuthToken(authService.getToken());

    return await axios.get<T>(apiUrl, {
        headers,
        params,
    });
}; */

export const getRequest = async <T>(url: string): Promise<T> => {
    const headers = {
        Accept: "application/json",
        platform: "web",
        Authorization: `Bearer ${authService.getToken()}`,
    }
    try {
      const response = await axios.get<T>(url, { headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error('Axios error:', error.message);
        throw new Error(`Request failed: ${error.message}`);
      } else {
        console.error('Unexpected error:', error);
        throw new Error('An unexpected error occurred');
      }
    }
  }
  


export const postRequest = async <T>(
    apiUrl: string,
    data: Record<string, any>
): Promise<AxiosResponse<T>> => {
    const headers: any = {
        Accept: "application/json",
        platform: "web",
        lang: localStorage.getItem("user-language") || "en",
    };

    const token = authService.getToken();
    setAuthToken(token);

    return await axios.post<T>(apiUrl, data, { headers });
};

export const deleteRequest = async <T>(
    apiUrl: string
): Promise<AxiosResponse<T>> => {
    const headers: any = {
        Accept: "application/json",
        platform: "web",
        lang: localStorage.getItem("user-language") || "en",
    };

    const token = authService.getToken();
    setAuthToken(token);

    return await axios.delete<T>(apiUrl, { headers });
};